var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.order
    ? _c(
        "v-container",
        { attrs: { fluid: "", "grid-list-xl": "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { "xs-8": "", "offset-xs2": "" } },
                [
                  _c("v-btn", { attrs: { small: "", to: "/orders" } }, [
                    _vm._v("Back to Orders")
                  ]),
                  _vm._v(" "),
                  _c("h1", { staticClass: "display-2" }, [
                    _vm._v("Order #" + _vm._s(_vm.order.orderCode))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "", "fill-height": "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs4: "", "offset-xs2": "" } },
                [
                  _c(
                    "v-card",
                    [
                      _c("v-card-title", [_c("h4", [_vm._v("Basic Details")])]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        [
                          _c("p", [
                            _c("b", [_vm._v("Order Code:")]),
                            _vm._v(" " + _vm._s(_vm.order.orderCode))
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("b", [_vm._v("Order Date:")]),
                            _vm._v(" " + _vm._s(_vm.orderDate))
                          ]),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              label: "Status",
                              items: [
                                { text: "Pending", value: "Pending" },
                                { text: "Processing", value: "Processing" },
                                {
                                  text: "Awaiting Check Measure",
                                  value: "Awaiting Check Measure"
                                },
                                {
                                  text: "Sent to Factory",
                                  value: "Sent to Factory"
                                },
                                {
                                  text: "Completed by Factory",
                                  value: "Completed by Factory"
                                },
                                {
                                  text: "Sent to Customer",
                                  value: "Sent to Customer"
                                },
                                { text: "Quote", value: "Quote" },
                                { text: "Archived", value: "Archived" },
                                { text: "Queried", value: "Queried" },
                                {
                                  text: "Need to Book Check Measure",
                                  value: "Need to Book Check Measure"
                                },
                                { text: "Checkout", value: "Checkout" }
                              ]
                            },
                            model: {
                              value: _vm.order.status,
                              callback: function($$v) {
                                _vm.$set(_vm.order, "status", $$v)
                              },
                              expression: "order.status"
                            }
                          }),
                          _vm._v(" "),
                          _vm.order.sentToFactoryBy &&
                          _vm.order.status === "Sent to Factory"
                            ? _c(
                                "p",
                                {
                                  staticStyle: {
                                    color: "red",
                                    "margin-top": "-10px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "Sent by: " +
                                      _vm._s(
                                        _vm.order.sentToFactoryBy.firstName
                                      )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("v-textarea", {
                            attrs: { label: "Remarks", rows: "2" },
                            model: {
                              value: _vm.order.remarks,
                              callback: function($$v) {
                                _vm.$set(_vm.order, "remarks", $$v)
                              },
                              expression: "order.remarks"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-textarea", {
                            attrs: {
                              label: "Delivery Instructions",
                              rows: "2"
                            },
                            model: {
                              value: _vm.order.deliveryInstructions,
                              callback: function($$v) {
                                _vm.$set(_vm.order, "deliveryInstructions", $$v)
                              },
                              expression: "order.deliveryInstructions"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-textarea", {
                            attrs: { label: "Order Instructions", rows: "3" },
                            model: {
                              value: _vm.order.orderInstructions,
                              callback: function($$v) {
                                _vm.$set(_vm.order, "orderInstructions", $$v)
                              },
                              expression: "order.orderInstructions"
                            }
                          }),
                          _vm._v(" "),
                          _c("p", [
                            _c("b", [
                              _vm._v(
                                "Authority to leave delivery without signature: "
                              )
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.order.authorityToLeave ? "Yes" : "No"
                                )
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs4: "" } },
                [
                  _c(
                    "v-card",
                    [
                      _c("div", { staticClass: "right delivery-install" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.order.install > 0 ? "Install" : "Delivery"
                            ) +
                            " "
                        )
                      ]),
                      _vm._v(" "),
                      _c("v-card-title", [_c("h4", [_vm._v("Customer")])]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm.order.customerID
                          ? _c(
                              "div",
                              [
                                _c(
                                  "v-list",
                                  [
                                    _c(
                                      "v-list-tile",
                                      [
                                        _c("v-list-tile-content", [
                                          _c("b", [_vm._v("Shipping Address")])
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-tile",
                                      [
                                        _c("v-list-tile-content", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.order.customerID.firstName
                                              ) +
                                              " " +
                                              _vm._s(
                                                _vm.order.customerID.lastName
                                              ) +
                                              " (" +
                                              _vm._s(
                                                _vm.order.customerID.email
                                              ) +
                                              ")"
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.order.customerID.phone
                                              ) +
                                              "\n                "
                                          )
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-tile",
                                      [
                                        _c("v-list-tile-content", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.order.customerID.address
                                                .address
                                            )
                                          ),
                                          _c("br"),
                                          _vm._v(
                                            _vm._s(
                                              _vm.order.customerID.address.city
                                            ) +
                                              " " +
                                              _vm._s(
                                                _vm.order.customerID.address
                                                  .suburb
                                              ) +
                                              " " +
                                              _vm._s(
                                                _vm.order.customerID.address
                                                  .state
                                              ) +
                                              " " +
                                              _vm._s(
                                                _vm.order.customerID.address
                                                  .postcode
                                              )
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.order.customerID.billingAddress
                                  ? _c(
                                      "v-list",
                                      [
                                        _c(
                                          "v-list-tile",
                                          [
                                            _c("v-list-tile-content", [
                                              _c("b", [
                                                _vm._v("Billing Address")
                                              ])
                                            ])
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-tile",
                                          [
                                            _c("v-list-tile-content", [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.order.customerID
                                                      .billingFirstName
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.order.customerID
                                                      .billingLastName
                                                  ) +
                                                  " (" +
                                                  _vm._s(
                                                    _vm.order.customerID
                                                      .billingEmail
                                                  ) +
                                                  ")"
                                              ),
                                              _c("br"),
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.order.customerID
                                                      .billingContactNumber
                                                  ) +
                                                  "\n                "
                                              )
                                            ])
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.order.customerID.billingCompanyName
                                          ? _c(
                                              "v-list-tile",
                                              [
                                                _c("v-list-tile-content", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.order.customerID
                                                        .billingCompanyName
                                                    )
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-tile",
                                          [
                                            _c("v-list-tile-content", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.order.customerID
                                                    .billingAddress.address
                                                )
                                              ),
                                              _c("br"),
                                              _vm._v(
                                                _vm._s(
                                                  _vm.order.customerID
                                                    .billingAddress.city
                                                ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.order.customerID
                                                      .billingAddress.suburb
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.order.customerID
                                                      .billingAddress.state
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    _vm.order.customerID
                                                      .billingAddress.postcode
                                                  )
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      small: "",
                                      color: "primary",
                                      to:
                                        "/customers/" + _vm.order.customerID._id
                                    }
                                  },
                                  [_vm._v("Go to Customer")]
                                )
                              ],
                              1
                            )
                          : _c(
                              "div",
                              [
                                _c("p", [
                                  _vm._v("No customer assigned to this order.")
                                ]),
                                _vm._v(" "),
                                _c("v-btn", { attrs: { color: "primary" } }, [
                                  _vm._v("Add")
                                ])
                              ],
                              1
                            )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("p"),
                  _vm._v(" "),
                  [
                    _c(
                      "table",
                      {
                        staticStyle: { "text-align": "center" },
                        attrs: { width: "100%" }
                      },
                      [
                        [
                          _c("thead", [
                            _c("tr", [
                              _c("th", { attrs: { width: "10%" } }),
                              _vm._v(" "),
                              _c("th", { attrs: { width: "30%" } }, [
                                _vm._v("TWC Order Number")
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { width: "30%" } }, [
                                _vm._v("TWC Status")
                              ]),
                              _vm._v(" "),
                              _c("th", { attrs: { width: "30%" } }, [
                                _vm._v("Estimated Completion")
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(this.orderTWCDetails, function(item, index) {
                              return _c("tr", { key: index }, [
                                _c("td", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.productAssets[item.type]
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(item.twcOrderNumber))]),
                                _vm._v(" "),
                                _c("td", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.getStatusHtml(item.twcStatus)
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      new Date(item.twcEstDueDate).getDate() +
                                        "/" +
                                        (new Date(
                                          item.twcEstDueDate
                                        ).getMonth() +
                                          1) +
                                        "/" +
                                        new Date(
                                          item.twcEstDueDate
                                        ).getFullYear()
                                    )
                                  )
                                ])
                              ])
                            }),
                            0
                          )
                        ]
                      ],
                      2
                    )
                  ]
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs8: "", "offset-xs2": "" } },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-container",
                        { attrs: { fluid: "", "grid-list-xl": "" } },
                        [
                          _c("h2", { staticClass: "display-1" }, [
                            _vm._v("Items")
                          ]),
                          _vm._v(" "),
                          _c("v-data-table", {
                            attrs: {
                              headers: _vm.headers,
                              items: _vm.order.items,
                              expand: _vm.expand,
                              "item-key": "name"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "items",
                                  fn: function(props) {
                                    return [
                                      _c(
                                        "tr",
                                        {
                                          on: {
                                            click: function($event) {
                                              props.expanded = !props.expanded
                                            }
                                          }
                                        },
                                        [
                                          _c("td", [
                                            _vm._v(_vm._s(props.item.name))
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(_vm._s(props.item.type))
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(_vm._s(props.item.width))
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(_vm._s(props.item.drop))
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "$" +
                                                _vm._s(
                                                  props.item.total.toFixed(2)
                                                )
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "expand",
                                  fn: function(props) {
                                    return [
                                      _c(
                                        "v-card",
                                        { attrs: { flat: "" } },
                                        [
                                          _c(
                                            "v-card-text",
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    display: "block"
                                                  }
                                                },
                                                [
                                                  _c("b", [
                                                    _vm._v("Fabric & Colour:")
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        props.item.fabric.name
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        props.item.color.name
                                                      )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                props.item.variations,
                                                function(variation, index) {
                                                  return _c(
                                                    "span",
                                                    {
                                                      key: index,
                                                      staticStyle: {
                                                        display: "block"
                                                      }
                                                    },
                                                    [
                                                      index != "secondFabric" &&
                                                      index != "secondColor"
                                                        ? _c("span", [
                                                            _c("b", [
                                                              _vm._v(
                                                                _vm._s(index) +
                                                                  ":"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  variation
                                                                )
                                                            )
                                                          ])
                                                        : _c("span", [
                                                            _c("b", [
                                                              _vm._v(
                                                                _vm._s(index) +
                                                                  ":"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  variation.name
                                                                )
                                                            )
                                                          ])
                                                    ]
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "footer",
                                  fn: function() {
                                    return [
                                      _c(
                                        "td",
                                        {
                                          attrs: { colspan: _vm.headers.length }
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              "Total: $" +
                                                _vm._s(
                                                  _vm.order.subTotal.toFixed(2)
                                                )
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              3191540757
                            )
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs8: "", "offset-xs2": "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { large: "", color: "primary" },
                      on: { click: _vm.updateOrder }
                    },
                    [_vm._v("Update")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        large: "",
                        outline: "",
                        color: "primary",
                        to: "/twc/" + _vm.order._id
                      }
                    },
                    [_vm._v("Send to Factory")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39a32d94", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39a32d94","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/Order.vue
// module id = null
// module chunks = 